var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { getGlobalState } from './GlobalState';
/**
 * Get the price for review for document based on the partners a user have.
 *
 * @param {string} product
 *
 * @returns {number}
 */
export const getProductPrice = (product) => __awaiter(void 0, void 0, void 0, function* () {
    const applicationUrl = getGlobalState('application_url');
    const response = yield axios.get(`${applicationUrl}/api/payment/price/product/${product}`);
    return response.data;
});
export default getProductPrice;
